import React from "react";

import ChatOptionsProvider, {
  useChatOptions,
} from "MessagingV2/providers/ChatOptionsProvider";
import { CHAT_SCREEN_MODE } from "MessagingV2/modules/Utils";
import SummaryInnerModal from "./SummaryInnerModal";

const SummarisePreviewModal = props => {
  const { chatId, activeUserId } = useChatOptions();

  // We need to override the screen mode to widget below this component hierarchy
  // So using nested ChatOptionsProvider to override the screen mode
  return (
    <ChatOptionsProvider
      chatId={chatId}
      activeUserId={activeUserId}
      screenMode={CHAT_SCREEN_MODE.WIDGET}
      isPreviewMessagesModal
    >
      <SummaryInnerModal {...props} />
    </ChatOptionsProvider>
  );
};

SummarisePreviewModal.propTypes = {};

export default SummarisePreviewModal;
